import { generateAutomationName } from "../../../helpers/generateAutomationName";

export const linksDataAutomation = {
    container: generateAutomationName("home", ["header", "links", "container"]),
    title: generateAutomationName("home", ["header", "links", "title"]),
    link: (name: string) => generateAutomationName("home", ["header", "links", "link", name]),
};
